import { readable, writable } from "svelte/store";
import { SERVICE_URL } from "../environment";
import { User } from "../Model/User";
export class SessionService {
    constructor() {
        this._rememberSession = false;
        this._accessToken = null;
        this._user = null;
        this._isLoggedIn = writable(false);
        this.isLoggedIn = readable(false, set => this._isLoggedIn.subscribe(set));
        this.loadSession();
    }
    get accessToken() {
        return this._accessToken;
    }
    get user() {
        return this._user;
    }
    async startSession(accessToken, remember) {
        const user = await this.getUser(accessToken);
        this._rememberSession = remember;
        this._accessToken = accessToken;
        this._user = user;
        this.storeSession();
        this._isLoggedIn.set(true);
    }
    closeSession() {
        this._rememberSession = false;
        this._accessToken = null;
        this._user = null;
        const storage = this._rememberSession ? window.localStorage : window.sessionStorage;
        window.localStorage.removeItem('remember_session');
        storage.removeItem('access_token');
        storage.removeItem('current_user');
        this._isLoggedIn.set(false);
    }
    async getUser(accessToken) {
        const response = await fetch(`${SERVICE_URL}/user`, {
            headers: {
                'X-Access-Token': accessToken
            }
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el usuario actual.');
        }
        const content = await response.json();
        return this.createUser(Object.assign(Object.assign({}, content), { rolId: content.rol_id }));
    }
    loadSession() {
        this._rememberSession = window.localStorage.getItem('remember_session') === '1';
        const storage = this._rememberSession ? window.localStorage : window.sessionStorage;
        if (!storage.getItem('access_token')) {
            return;
        }
        this._accessToken = storage.getItem('access_token');
        this._user = this.createUser(JSON.parse(storage.getItem('current_user')));
        this._isLoggedIn.set(true);
    }
    storeSession() {
        const storage = this._rememberSession ? window.localStorage : window.sessionStorage;
        window.localStorage.setItem('remember_session', this._rememberSession ? '1' : '0');
        storage.setItem('access_token', this._accessToken);
        storage.setItem('current_user', JSON.stringify(this._user));
    }
    createUser({ id, rolId, foreman, name, image }) {
        return new User(id, rolId, foreman, name, image);
    }
}
